import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { SketchField, Tools } from 'react-sketch';

import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { BlueCloseIcon, TrashIcon } from '../../images/icons/WrapSvg';

class SignDialog extends React.Component {
    render() {
        const { fullScreen } = this.props;

        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={this.props.open}
                    onClose={() => this.handleClose('cancel')}
                    aria-labelledby="responsive-dialog-title"
                    className="bg_cool_grey_two"
                >
                    <div className="flex_full_column height100 width100 signPad bg_cool_grey_two">
                        <div className="flex_auto_row">
                            <BlueCloseIcon
                                className={'c_white margin_top_18 margin_left_18 hand'}
                                onClick={() => this.handleClose()}
                            />
                            <div className="flex_full_row elements_from_right">
                                <TrashIcon
                                    className={'c_white margin_top_18 margin_right_18 hand'}
                                    onClick={() => this.handleClose('delete')}
                                />
                            </div>
                        </div>
                        <div className="flex_full_column align_center elements_center">
                            <div className="bg_white">
                                <SketchField
                                    name="sketch"
                                    ref="_sketch"
                                    width="320px"
                                    height="320px"
                                    tool={Tools.Pencil}
                                    lineColor="black"
                                    lineWidth={3}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }

    handleChange = (event) => {
        this.props.handleChange(event.target.value);
    };

    handleClose = (action) => {
        this.props.handleClose(action ? action : this.refs._sketch.toDataURL());
    };
}

SignDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
};

SignDialog = injectIntl(SignDialog);

export default withMobileDialog()(SignDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/Sign.js